module.exports = __webpack_public_path__ + "static/media/timing.898e7db3.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/pic/timing.PNG
// module id = 567
// module chunks = 0